/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { strings } from "../../../../common/Strings/Strings";
import { getGeneralError } from "../../../../util/helperFunctions";
import UserPetApi from "../../../../api/UserPetApi";
import { PetDetailsResponse } from "../../../../models/pet/PetDetailsResponse";
import CheckBox from "../../../../components/ReactHookFormFields/General/CheckBox";
import Textarea from "../../../../components/ReactHookFormFields/General/Textarea";
import CombinedSelect from "../../../../components/ReactHookFormFields/General/Select/CombinedSelect";
import AlertBox from "../../../../components/AlertBox";
import moment from "moment";

const FinishReservation: React.FC = () => {
  const [pets, setPets] = useState<PetDetailsResponse[]>([]);
  const [error, setError] = useState<string | null>(null);

  const {
    control,
    getValues,
    register,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    const getMyPets = async () => {
      try {
        const response = await UserPetApi.getUserPets();
        setPets(response.data.map((p) => p.userPetDetails));
      } catch (err) {
        setError(await getGeneralError(err));
      }
    };

    void getMyPets();
  }, []);

  return (
    <>
      <div className="space-y-6 w-full">
        <div>
          <h2 className="text-lg font-semibold leading-tight text-zinc-800 lg:text-xl dark:text-white">
            {strings.newAppointmentSubTitle4}
          </h2>
          <p>{getValues("reservationPeriod").start && moment(getValues("reservationPeriod").start).format("LLL")}</p>
        </div>
        <AlertBox message={error} />
        <CombinedSelect
          allowNew={false}
          control={control}
          label={strings.pet}
          labelKey="name"
          name="pet"
          options={pets}
          required
        />
        <Textarea
          name="description"
          label={strings.description}
          placeholder={strings.writeSymptoms}
          minRows={3}
          register={register}
          error={errors.description}
          required
        />
        <CheckBox
          name="userInformedAboutGdpr"
          label={strings.iAcceptThatOrganizationWillReceiveMyData}
          register={register}
          required
        />
      </div>
    </>
  );
};

export default FinishReservation;
